import request, { _POST, requestExport } from "@/services/request";

const BASE = "/admin/opportunity/payment";

/** 商机中心小程序 appId */
const OPPORTUNITY_APP_ID = "wx302be520d3002c53";

export type OpportunityPaymentAdminScope = {
  appId: string;
  /** 0 正式、1 沙箱；不传表示全部 */
  env?: number;
};

export type MembershipPaymentOrder = {
  orderNo?: string;
  channelId?: string;
  payerId?: string;
  payerName?: string;
  offerCode?: string;
  planCode?: string;
  amountCent?: string | number;
  originalPriceCent?: string | number;
  termUnit?: number;
  termValue?: number;
  paymentState?: number;
  /** 0 正式、1 沙箱；正式为 0 时响应里可能省略 */
  env?: number;
  createdAt?: string;
  orderType?: number;
  expiresAt?: string;
  paidAt?: string;
  userInfo?: Record<string, any>;
  wechatTransactionId?: string;
  displayState?: number;
  displayStateText?: string;
  refundedAt?: string;
  inviterUserInfo?: {
    openId?: string;
    name?: string;
  };
};

export type MemberOrderListReq = {
  scope?: OpportunityPaymentAdminScope;
  channelId?: string;
  displayState?: number;
  payChannel?: number;
  pageIndex?: number;
  pageSize?: number;
  orderNo?: string;
  userKeyword?: string;
  createdFrom?: string;
  createdBefore?: string;
};

export type MemberOrderListRsp = {
  orders?: MembershipPaymentOrder[];
  total?: string | number;
};

/** 1 待支付 2 已支付 3 已关闭（展示为已失效） */
export const MemberOrderPaymentStateMap = new Map<number, string>([
  [1, "待支付"],
  [2, "已支付"],
  [3, "已失效"],
]);

export const getMemberOrderScope = (env?: number): OpportunityPaymentAdminScope => {
  const scope: OpportunityPaymentAdminScope = { appId: OPPORTUNITY_APP_ID };
  if (env === 0 || env === 1) scope.env = env;
  return scope;
};

export const getMemberOrderList = async (
  params: MemberOrderListReq
): Promise<{ list: MembershipPaymentOrder[]; total: number }> => {
  const res = await request<MemberOrderListRsp, MemberOrderListReq>(_POST, `${BASE}/order/list`)(params);
  return {
    list: res.data?.orders ?? [],
    total: Number(res.data?.total ?? 0),
  };
};

/** 导出请求与列表相同，不带分页；后端按筛选条件生成 xlsx */
export const exportMemberOrderList = (params: MemberOrderListReq = {}) => {
  const { scope, channelId, displayState, payChannel, orderNo, userKeyword, createdFrom, createdBefore } = params;
  return requestExport<MemberOrderListReq>(`${BASE}/order/export`, {
    method: _POST,
    params: { scope, channelId, displayState, payChannel, orderNo, userKeyword, createdFrom, createdBefore },
    callback: (url) => {
      const link = document.createElement("a");
      link.href = url;
      link.download = `会员订单导出_${Date.now()}.xlsx`;
      link.click();
    },
  });
};

const memberOrder = {
  getMemberOrderList,
  exportMemberOrderList,
};

export default memberOrder;
